<template>
  <div class="container">
    <h1>JavaScript  Sending email example code using Axios</h1>
    <JsGist />
  </div>
</template>

<script>
import JsGist from './JsGist'

export default {
  name: 'Js',
  components: {
    JsGist
  }

}
</script>

<style scoped>
img{
  width: 90%;
}

</style>
